<template>
  <a class="home-project-card" :href="safeHref">
    <span class="home-project-card__media home-card-frame">
      <span v-if="badge" class="home-project-card__badge">{{ badge }}</span>
      <img class="home-project-card__cover" :src="project.project_thumb" :alt="project.name" loading="lazy" @error="onImageError" />
      <span
        v-if="project.ageRatingLabel"
        class="home-age-rating"
        :class="project.ageRatingClass"
        :aria-label="`Classificacao indicativa ${project.ageRatingLabel}`"
      >
        {{ project.ageRatingLabel }}
      </span>
    </span>
    <span class="home-project-card__details">
      <strong class="home-project-card__title">{{ project.name }}</strong>
      <span class="home-project-card__stats">
        <span v-for="metric in socialMetrics" :key="metric.key" class="home-project-card__stat">
          <v-icon>{{ metric.icon }}</v-icon>
          <span>{{ metric.value }}</span>
        </span>
      </span>
    </span>
  </a>
</template>

<script>
import { HOME_PROJECT_FALLBACK, setImageFallback } from "@/utils/homeImageFallbacks";
import { compactNumber, projectMetrics } from "@/utils/homeMetrics";
import { sanitizeHttpUrl } from "@/utils/safeNavigation";

export default {
  name: "HomeProjectCard",
  props: {
    project: { type: Object, required: true },
    badge: { type: String, default: "" },
  },
  computed: {
    safeHref() {
      return sanitizeHttpUrl(this.project.href) || sanitizeHttpUrl('/descobrir/categorias');
    },
    socialMetrics() {
      return projectMetrics(this.project, { includeViews: false }).map(metric => ({
        ...metric,
        value: compactNumber(metric.value),
      }));
    },
  },
  methods: {
    onImageError(event) {
      setImageFallback(event, HOME_PROJECT_FALLBACK);
    },
  },
};
</script>
